module.exports = __webpack_public_path__ + "assets/img/00064.7a3e92c7.png";